import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: 560,
      marginBottom: 160,
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    questionGroup: {
      marginBottom: theme.spacing(1.5),
    },
    bannerWrapper: {
      margin: theme.spacing(-2, 0, 3),
    },
    textAligned: {
      [theme.breakpoints.down('lg')]: {
        textAlign: 'left',
      },
      [theme.breakpoints.up('md')]: {
        textAlign: 'right',
      },
    },
  })
);

export default useStyles;
